import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-institute-and-center',
  templateUrl: './institute-and-center.component.html',
  styleUrls: ['./institute-and-center.component.scss']
})
export class InstituteAndCenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
